import type { ISendContactFormValues } from "@gik/contact/components/ContactForm/ContactForm";
import { dotnetApi } from "@gik/core/api/ky/dotnetApi";

export async function sendContact(values: ISendContactFormValues) {
	const response = await dotnetApi.post(`contact/send`, {
		json: values,
	});

	if (!response.ok) {
		throw new Error((await response.json<{ message: string }>()).message);
	}
}
